import type { WelcomeBonusProduct } from '../../../../@types/api';
import {
  AFFILIATE_BONUS_CATEGORY,
  AFFILIATE_CAMPAIGN_PRODUCT,
  VALIDITY_PERIOD,
  WELCOME_BONUS_ELIGIBILITY,
  WELCOME_BONUS_STATUS,
  WELCOME_BONUS_TYPE,
  WELCOME_BONUS_WAGERING_MODE,
} from '../../../../constants/enums';
import type { WelcomeBonusCreateFormData } from '../../../../schema';
import { getCasinoProductDefaults } from './products/casino';
import { getSportsbookProductDefaults } from './products/sportsbook';

export const getWelcomeBonusCreateDefaultValues = (): WelcomeBonusCreateFormData => ({
  name: '',
  product: AFFILIATE_CAMPAIGN_PRODUCT.SPORTSBOOK,
  eligibilityCriteria: WELCOME_BONUS_ELIGIBILITY.FIRST_TIME_DEPOSIT,
  validityPeriod: VALIDITY_PERIOD.ONGOING,
  status: WELCOME_BONUS_STATUS.READY,
  welcomeBonusScope: null,
  affiliateIds: [],
  bonusType: WELCOME_BONUS_TYPE.UNLOCK,
  bonusCategory: AFFILIATE_BONUS_CATEGORY.PERCENTAGE,
  wageringMode: WELCOME_BONUS_WAGERING_MODE.FIXED_AMOUNT,
  bonusPercentage: null,
  fixedAmount: null,
  capLimit: null,
  minDepositAmount: null,
  timeframe: 30,
  wageringRequirement: null,
  multiplier: null,
  description: '',
  ...getSportsbookProductDefaults(),
});

// Product changes preserve common fields but intentionally discard the previous Product configuration.
export const switchWelcomeBonusProduct = (
  currentValues: WelcomeBonusCreateFormData,
  product: WelcomeBonusProduct
): WelcomeBonusCreateFormData => ({
  ...currentValues,
  product,
  ...(product === AFFILIATE_CAMPAIGN_PRODUCT.CASINO ? getCasinoProductDefaults() : getSportsbookProductDefaults()),
});
